import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
export type ItemDetailFragment = { __typename?: 'Item', id: string, name: string, arrival_date: string, booked_by_user_id?: string | null, booked_by_user_name?: string | null, item_type: { __typename?: 'ItemType', id: number, name: string, image_url?: string | null, color_hex_code?: string | null, category: Types.ItemTypeCategory, archived: boolean, epc_asset_id: number } };

export const ItemDetailFragmentDoc = gql`
    fragment ItemDetail on Item {
  id
  name
  arrival_date
  booked_by_user_id
  booked_by_user_name
  item_type {
    id
    name
    image_url
    color_hex_code
    category
    archived
    epc_asset_id
  }
}
    `;